<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    class="dialog-drag-display event-history-view-dialog"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    style="margin-top:600px;"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>{{title}}</v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon v-show="!fullScreen" class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn v-show="!fullScreen" small text icon @click="removeDialog">
        <icon-svg class="ml-2" iconName="close" />
      </v-btn>
    </template>
    <!-- [S]  Popup body-->
    <v-row no-gutters class="scanner-section pt-4 pl-4 pr-4">
      <!-- Scanner Data -->
      <v-col class="pl-0 pb-0 pt-0" cols="12" lg="12" md="12">
        <v-row no-gutters>
          <v-col cols="12" class="scanner-grid-pd zoom-scanner-file">
            <v-row no-gutters class="scanner-icon">
              <v-col class="pa-0 text-right btn-expand" cols="12" lg="2" md="2">
                <v-btn x-small text icon @click="expandView">
                  <icon-svg iconName="expand" />
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters class="text-view-scanner">
              <div class="CodeMirror json-color-format">
                <ScannerViewer
                  v-model="scannerFileContent"
                  :options="this.cmOption"
                  ref="scannerFile"
                ></ScannerViewer>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <!-- Scanner Data -->
    </v-row>
    <v-divider class="ml-0 mr-0 mt-2 divder-popup" inset></v-divider>
    <v-row class="ml-0 mr-0">
      <v-col class="button-col action-col" lg="12">
        <div class="btn-form-control text-right mr-4">
          <v-btn class="btn btn-delete" @click="removeDialog">{{$t('btn.common.close')}}</v-btn>
        </div>
      </v-col>
    </v-row>
  </dialog-drag>
</template>

<script>
import DialogDrag from "@/vue-dlb/components/vue-dialog-drag2.vue";
import { mapState } from "vuex";

// language
import "codemirror/mode/swift/swift.js";

// theme css
import "codemirror/theme/rubyblue.css";

// active-line.js
import "codemirror/addon/selection/active-line.js";

// styleSelectedText
import "codemirror/addon/selection/mark-selection.js";
import "codemirror/addon/search/searchcursor.js";

// highlightSelectionMatches
import "codemirror/addon/scroll/annotatescrollbar.js";
import "codemirror/addon/search/matchesonscrollbar.js";
import "codemirror/addon/search/searchcursor.js";
import "codemirror/addon/search/match-highlighter.js";

// keyMap
import "codemirror/mode/clike/clike.js";
import "codemirror/addon/edit/matchbrackets.js";
import "codemirror/addon/comment/comment.js";
import "codemirror/addon/dialog/dialog.js";
import "codemirror/addon/dialog/dialog.css";
import "codemirror/addon/search/searchcursor.js";
import "codemirror/addon/search/search.js";
import "codemirror/keymap/sublime.js";

// foldGutter
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/addon/fold/brace-fold.js";
import "codemirror/addon/fold/comment-fold.js";
import "codemirror/addon/fold/foldcode.js";
import "codemirror/addon/fold/foldgutter.js";
import "codemirror/addon/fold/indent-fold.js";
import "codemirror/addon/fold/markdown-fold.js";
import "codemirror/addon/fold/xml-fold.js";

var encoding = require("encoding");

import ScannerViewer from "@/vue-dlb/components/viewers/codemirror.vue";
import IconSvg from "@/vue-caas/components/IconBase.vue";
import $ from "jquery";

export default {
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    fileViewInfo: Object,
  },
  components: {
    DialogDrag,
    ScannerViewer,
    IconSvg,
  },
  name: "monitoring-file-view-window",

  data: () => ({
    scannerFileContent: "",
    fullScreen: false,
  }),

  computed: {
    cmOption() {
      if (this.$vuetify.theme.isDark == true) {
        return {
          tabSize: 4,
          lineWrapping: true,
          foldGutter: true,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          readOnly: false,
          keyMap: "sublime",
          mode: "text/x-swift",
          theme: "rubyblue",
        };
      }
      return {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        readOnly: false,
        keyMap: "sublime",
        mode: "text/x-swift",
        theme: "default",
      };
    },
  },

  watch: {
    "options.item.id"() {
      this.initialize();
    },
  },

  methods: {
    expandView() {
      this.$refs.scannerFile.cminstance.setOption("fullScreen", true);
      //Create label, button close expand view
      var div = document.createElement("div");
      div.innerHTML = this.$t("msg.mapBuilder.addLabelHtml", {
        title: this.title,
        iconClass: "icon-collapse-scanner",
      });
      div.className = this.$t("msg.mapBuilder.addRowClass", {
        rowClass: "scanner-add-row",
      });
      $(".zoom-scanner-file .CodeMirror-fullscreen").prepend(div);
      this.fullScreen = true;
      $(".icon-collapse-scanner").on(
        "click",
        { type: "scanner" },
        this.closeExpand
      );
    },
    closeExpand(e) {
      if (e.data.type == "scanner") {
        this.fullScreen = false;
        $(".scanner-add-row").remove();
        this.$refs.scannerFile.cminstance.setOption("fullScreen", false);
        if (typeof this.$refs.resultBuild !== "undefined") {
          this.$refs.resultBuild.cminstance.setOption("fullScreen", false);
        }
      }
    },
    initialize() {
      // console.log(this.options.item.id)
      this.scannerFileContent = JSON.stringify(
        JSON.parse(this.options.item.fileContent),
        null,
        4
      );
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
  created() {
    this.initialize();
  },
};
</script>

<style>
.event-history-view-dialog .dialog-drag .dialog-body {
  padding: 0px !important;
}
.event-history-view-dialog .scanner-section {
}
.event-history-view-dialog .scanner-grid-pd {
  height: auto;
  width: 500px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 3px;
  padding: 0px !important;
  background: transparent !important;
  margin-top: -10px !important;
}
</style>>